import { render, staticRenderFns } from "./Fad.vue?vue&type=template&id=231431fa"
import script from "./Fad.vue?vue&type=script&lang=js"
export * from "./Fad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231431fa')) {
      api.createRecord('231431fa', component.options)
    } else {
      api.reload('231431fa', component.options)
    }
    module.hot.accept("./Fad.vue?vue&type=template&id=231431fa", function () {
      api.rerender('231431fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Fad.vue"
export default component.exports